"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var syncerror_1 = require("./syncerror");
/**
 * Deep-clone an object. Note that this does not work on object containing
 * functions.
 * @param {object} obj - the object to deep-clone
 * @returns {object}
 */


function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

exports.deepClone = deepClone;

function validateOptionalTtl(ttl) {
  var validTtl = ttl === undefined || isNonNegativeInteger(ttl);

  if (!validTtl) {
    throw new syncerror_1["default"]("Invalid TTL value, expected a positive integer, was '".concat(ttl, "'"), 400, 54011);
  }
}

exports.validateOptionalTtl = validateOptionalTtl;

function validateMandatoryTtl(ttl) {
  var validTtl = isNonNegativeInteger(ttl);

  if (!validTtl) {
    throw new syncerror_1["default"]("Invalid TTL value, expected a positive integer, was '".concat(ttl, "'"), 400, 54011);
  }
}

exports.validateMandatoryTtl = validateMandatoryTtl;

function validatePageSize(pageSize) {
  var validPageSize = pageSize === undefined || isPositiveInteger(pageSize);

  if (!validPageSize) {
    throw new syncerror_1["default"]("Invalid pageSize parameter. Expected a positive integer, was '".concat(pageSize, "'."), 400, 54455);
  }
}

exports.validatePageSize = validatePageSize;

function isInteger(number) {
  return !isNaN(parseInt(number)) && isFinite(number);
}

function isPositiveInteger(number) {
  return isInteger(number) && number > 0;
}

function isNonNegativeInteger(number) {
  return isInteger(number) && number >= 0;
}